/**
 * Scan feature selectors
 * These selectors abstract away the internal structure of the scan state,
 * making it easier to refactor state structure without breaking components.
 */

/**
 * Select the selected pass from customer data
 * @param {Object} state - Redux state
 * @returns {Object|null} Selected pass object or null if not available
 */
export const selectSelectedPass = (state) => {
    const { customerData, selectedPassIndex } = state.scan;
    
    if (!customerData?.allPasses || selectedPassIndex === null || selectedPassIndex === undefined) {
        return null;
    }
    
    if (selectedPassIndex < 0 || selectedPassIndex >= customerData.allPasses.length) {
        return null;
    }
    
    return customerData.allPasses[selectedPassIndex] || null;
};

/**
 * Select the customer email from scan state
 * @param {Object} state - Redux state
 * @returns {string|null} Customer email or null if not available
 */
export const selectCustomerEmail = (state) => {
    return state.scan.customerData?.customerEmail || null;
};

/**
 * Select the customer name from scan state
 * @param {Object} state - Redux state
 * @returns {string|null} Customer name or null if not available
 */
export const selectCustomerName = (state) => {
    return state.scan.customerData?.customerName || null;
};

/**
 * Select all passes from customer data
 * @param {Object} state - Redux state
 * @returns {Array} Array of pass objects or empty array
 */
export const selectAllPasses = (state) => {
    return state.scan.customerData?.allPasses || [];
};

/**
 * Check if a pass is selected
 * @param {Object} state - Redux state
 * @returns {boolean} True if a pass is selected
 */
export const selectHasSelectedPass = (state) => {
    return selectSelectedPass(state) !== null;
};

